/* eslint-disable @bigbinary/neeto/use-neetoui-classes */
import { isNotPresent, isPresent } from "neetocist";

const LinkSection = ({ links }) => {
  if (isNotPresent(links)) return null;

  return (
    <>
      {links.map(
        ({ label, icon: Icon, changesCount, href, ...otherProps }, idx) => {
          const Tag = href ? "a" : "button";

          return (
            <Tag
              className="hover:bg-accent flex h-9 w-full items-center gap-2 rounded-md px-2.5 text-sm font-medium"
              data-testid="floating-action-menu-link-section"
              key={idx}
              type={href ? undefined : "button"}
              {...(href ? { href } : {})}
              {...otherProps}
            >
              {Icon && <Icon size={18} />}
              <span className="flex flex-grow items-center gap-2">
                {label}
                {isPresent(changesCount) && (
                  <span
                    className="bg-accent-foreground flex h-[1.125rem] min-w-[1.125rem] shrink-0 items-center justify-center rounded-full px-1 text-[10px] text-white select-none"
                    data-testid="help-section-menu-changes-count"
                  >
                    {changesCount}
                  </span>
                )}
              </span>
            </Tag>
          );
        }
      )}
    </>
  );
};

export default LinkSection;
